import { render } from "./VaIconFaster.vue?vue&type=template&id=94f7ad8a"
import script from "./VaIconFaster.vue?vue&type=script&lang=js"
export * from "./VaIconFaster.vue?vue&type=script&lang=js"

import "./VaIconFaster.vue?vue&type=style&index=0&id=94f7ad8a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__